import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid, CircularProgress, Typography, withStyles } from "@material-ui/core";
// // Shared layouts
import { enableConnection } from "../../redux/actions/connectionActions";

import styles from "./styles";

class ConnectionEnable extends Component {
  signal = true;

  state = {
    isLoading: true,
    loaded: false,
    error: false
  };

  async setEnabledConnection() {
    try {
      this.setState({ isLoading: true });
      let connectionId = localStorage.getItem("ConnectionId");
      let redirectUrl = window.location.href;
      await this.props.enableConnection(connectionId, redirectUrl);
      this.setState({ isLoading: false });
      if(!this.state.error || this.props.oauthStatus){
        localStorage.setItem("connected", connectionId);
      }
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error: true
        });
      }
    }
  } 


  UNSAFE_componentWillMount() {
    this.setEnabledConnection();
  }

  UNSAFE_componentWillUpdate(prevProps, prevState, snapshot) {
    // console.log(this.props);
  }

  closeWindow = () => {
    window.close();
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid className={classes.grid} container>
          <Grid className={classes.quoteWrapper} item lg={5}>
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography className={classes.quoteText} variant="h1">
                  Connect to all your data, and select from our library of actions, with no coding required.
                </Typography>
                <div className={classes.person}>
                  <Typography className={classes.name} variant="body1">
                    Responsum.ai
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid className={classes.content} item lg={7} xs={12}>
            <div className={classes.content}>
              <div className={classes.contentBody}>
                <form className={classes.form} onSubmit={this.handleSignIn}>
                  {this.state.isLoading ? (
                    <React.Fragment>
                      <Typography className={classes.title} variant="h2">
                        Connection Setup In Progress
                      </Typography>
                      <Typography className={classes.title} variant="body1">
                        We are enabling your connection. This will take just a few seconds
                      </Typography>
                      <CircularProgress className={classes.progress} />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {this.state.error || !this.props.oauthStatus ? (
                        <React.Fragment>
                          <Typography className={classes.title} variant="h2">
                            Connection Setup Error
                          </Typography>
                          <Typography className={classes.signUp} variant="body1">
                            Your connection setup has failed. Please contact our support so we can resolve issue with
                            your connection setup.
                          </Typography>
                          <Typography className={classes.signUp} variant="h6">
                            <Link className={classes.signUpUrl} onClick={this.closeWindow}>
                              Click here to close this window
                            </Link>
                          </Typography>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Typography className={classes.title} variant="h2">
                            Connection Setup Completed
                          </Typography>
                          <Typography className={classes.signUp} variant="body1">
                            Your connection setup has been completed. You can now use your connection in our chatbot or
                            trigger connection with voice.
                          </Typography>
                          <Typography className={classes.signUp} variant="h6">
                            <Link className={classes.signUpUrl} onClick={this.closeWindow}>
                              Click here to close this window
                            </Link>
                          </Typography>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                </form>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

ConnectionEnable.propTypes = {
  classes: PropTypes.object.isRequired,
  enableConnection: PropTypes.func
};

function mapStateToProps(state) {
  // console.log("kita", state);
  return {
    cognitoUser: state.auth.cognitoUser,
    skill: state.skill,
    oauthStatus: state.connections ? state.connections.oauthStatus : ""
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        enableConnection
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(ConnectionEnable))
);
